export default __webpack_public_path__ + "static/media/left.2cfbf37f.png";